// folder
export const FETCH_FOLDER_REQUEST = 'FETCH_FOLDER_REQUEST'
export const FETCH_FOLDER_SUCCESS = 'FETCH_FOLDER_SUCCESS'
export const FETCH_FOLDER_ERROR = 'FETCH_FOLDER_ERROR'
export const SET_FOLDER = 'SET_FOLDER'

// folders
export const FETCH_FOLDERS_REQUEST = 'FETCH_FOLDERS_REQUEST'
export const FETCH_FOLDERS_SUCCESS = 'FETCH_FOLDERS_SUCCESS'
export const FETCH_FOLDERS_ERROR = 'FETCH_FOLDERS_ERROR'
export const SET_WRITABLE_FOLDERS = 'SET_WRITABLE_FOLDERS'
export const SET_FOLDERS = 'SET_FOLDERS'

// folder modal
export const SET_FOLDER_MODAL_ID = 'SET_FOLDER_MODAL_ID'
export const SET_FOLDER_MODAL_IS_VISIBLE = 'SET_FOLDER_MODAL_IS_VISIBLE'

// folder form
export const FOLDER_FORM_REQUEST = 'FOLDER_FORM_REQUEST'
export const FOLDER_FORM_SUCCESS = 'FOLDER_FORM_SUCCESS'
export const FOLDER_FORM_ERROR = 'FOLDER_FORM_ERROR'
export const SET_NAME = 'SET_NAME'
export const SET_ALTERNATIVE_NAME = 'SET_ALTERNATIVE_NAME'
export const SET_DESCRIPTION = 'SET_DESCRIPTION'
export const SET_TEAM_ID = 'SET_TEAM_ID'
export const SET_EXPORT_ENABLED = 'SET_EXPORT_ENABLED'

// folder destroy
export const DESTROY_FOLDERS_REQUEST = 'DESTROY_FOLDERS_REQUEST'
export const DESTROY_FOLDERS_SUCCESS = 'DESTROY_FOLDERS_SUCCESS'
export const DESTROY_FOLDERS_ERROR = 'DESTROY_FOLDERS_ERROR'




// WEBPACK FOOTER //
// ./src/store/modules/folders/types.js